import React from 'react'

const SvgCandle = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M11.751 2.367C11.813 2.282 12 2 12 2l.249.367.158.222c.113.158.233.327.363.506.894 1.222 2.23 3.057 2.23 4.11 0 .77-.34 1.467-.883 1.973A3.1 3.1 0 0112 10a3.141 3.141 0 01-2.117-.812C9.339 8.682 9 7.986 9 7.217c0-1.055 1.336-2.9 2.23-4.122.204-.275.374-.507.521-.728zM4 21a1 1 0 011-1h4v-7a2 2 0 012-2h2a2 2 0 012 2v7h4a1 1 0 011 1v1H4v-1z' />
  </svg>
)

export default SvgCandle
